import { Injectable } from '@angular/core';
import { FeatureTogglesApiService } from '../http/feature-toggles-api.service';
import AutoMapperService from './auto-mapper.service';
import { FeatureToggleResponse } from '../../models/feature-toggle-response';
import { FeatureToggle } from 'src/app/shared/models/feature-toggle';

@Injectable({
    providedIn: 'root'
})
export class FeatureToggleService {
    constructor(private service: FeatureTogglesApiService) {}

    getFeatureFlagsByName(name: string): FeatureToggle {
        const response = this.service.getCachedFeatureToggles();
        const featureFlags =
            response?.map(data =>
                AutoMapperService.mapToApplicationModel<FeatureToggleResponse, FeatureToggle>(data)
            ) ?? [];

        const result = featureFlags.find(featureFlag => featureFlag.name == name);

        return result ? result : { enabled: false, name: name };
    }
}
